import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaShoppingCart, FaMapMarkerAlt } from 'react-icons/fa';
import { useCart } from '../context/CartContext.tsx';
import './Header.css';

const Header: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const { getItemCount } = useCart();


  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const itemCount = getItemCount();

  return (
    <motion.header
      className={`header ${scrolled ? 'scrolled' : ''}`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="container header-content">
        <Link to="/" className="logo">
          <motion.div
            className="logo-container"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <img src="/logo.png" alt="Yolla Food" className="logo-image" />
            <span className="logo-text">Yolla Food</span>
          </motion.div>
        </Link>

        <div className="nav-address">
          <FaMapMarkerAlt />
          <span>81 Rue Bernard Palissy, 45500 Gien</span>
        </div>

        <div className="header-actions">
          <Link to="/order" className="cart-icon">
            <FaShoppingCart />
            {itemCount > 0 && (
              <motion.span
                className="cart-badge"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ type: 'spring', stiffness: 500 }}
              >
                {itemCount}
              </motion.span>
            )}
          </Link>
        </div>
      </div>
      
      {/* Mobile cart icon outside header-content */}
      <div className="mobile-cart-container">
        <Link to="/order" className="mobile-cart-icon">
          <FaShoppingCart />
          {itemCount > 0 && (
            <motion.span
              className="cart-badge"
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ type: 'spring', stiffness: 500 }}
            >
              {itemCount}
            </motion.span>
          )}
        </Link>
      </div>
    </motion.header>
  );
};

export default Header;